import {
  defaultVehicleCollection,
  vehicleCollectionState$,
} from '../VehicleCollectionSubjects';

import { useRxjsStore } from './useRxjsStore';

export const useVehicleCollectionSub = () => useRxjsStore(vehicleCollectionState$, defaultVehicleCollection);
